import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import useWindowSize from '../../hooks/useWindowSize.js';
import Dropdown from '../Dropdown/index.js';
import getHeaderTitles from './getHeaderTitles.js';
import { TableWrapper, Container, Dropdowns, DropdownWrapper, ErrorWrapper } from './Table.styles.js';

var Table = function Table(_ref) {
  var children = _ref.children,
    _ref$leftColumnAlignm = _ref.leftColumnAlignment,
    leftColumnAlignment = _ref$leftColumnAlignm === void 0 ? false : _ref$leftColumnAlignm,
    _ref$mobileComparison = _ref.mobileComparison,
    mobileComparison = _ref$mobileComparison === void 0 ? false : _ref$mobileComparison;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isError = _useState2[0],
    setIsError = _useState2[1];
  var _useState3 = useState(children),
    _useState4 = _slicedToArray(_useState3, 2),
    tableData = _useState4[0],
    setTableData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    leftColumnError = _useState6[0],
    setLeftColumnError = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    rightColumnError = _useState8[0],
    setRightColumnError = _useState8[1];
  var screenSize = useWindowSize();
  var isMobileView = screenSize.width < 940;
  var headerCells = useMemo(function () {
    var _table$props;
    var table = children.find(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === 'table';
    });
    return table === null || table === void 0 || (_table$props = table.props) === null || _table$props === void 0 || (_table$props = _table$props.children) === null || _table$props === void 0 || (_table$props = _table$props[0]) === null || _table$props === void 0 || (_table$props = _table$props.props) === null || _table$props === void 0 ? void 0 : _table$props.children;
  }, [children]);
  var showMobileComparison = isMobileView && mobileComparison && !isError && (headerCells === null || headerCells === void 0 ? void 0 : headerCells.length) > 1;
  var columnOptions = useMemo(function () {
    return headerCells === null || headerCells === void 0 ? void 0 : headerCells.map(function (cell) {
      var _cell$props, _cell$props$children;
      var headerChildren = (cell === null || cell === void 0 || (_cell$props = cell.props) === null || _cell$props === void 0 || (_cell$props = _cell$props.children) === null || _cell$props === void 0 || (_cell$props = _cell$props[1]) === null || _cell$props === void 0 || (_cell$props = _cell$props.props) === null || _cell$props === void 0 ? void 0 : _cell$props.children) || ((_cell$props$children = cell.props.children) === null || _cell$props$children === void 0 || (_cell$props$children = _cell$props$children[0].props) === null || _cell$props$children === void 0 ? void 0 : _cell$props$children.children);
      var headerTitles = getHeaderTitles(headerChildren);
      return {
        value: cell === null || cell === void 0 ? void 0 : cell.key,
        label: headerTitles === null || headerTitles === void 0 ? void 0 : headerTitles.find(function (text) {
          return typeof text === 'string';
        })
      };
    });
  }, [headerCells] // eslint-disable-line react-hooks/exhaustive-deps
  );
  var _useState9 = useState(function () {
      return columnOptions === null || columnOptions === void 0 ? void 0 : columnOptions[0];
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    leftColumnFilter = _useState10[0],
    setLeftColumnFilter = _useState10[1];
  var _useState11 = useState(function () {
      return columnOptions === null || columnOptions === void 0 ? void 0 : columnOptions[1];
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    rightColumnFilter = _useState12[0],
    setRightColumnFilter = _useState12[1];
  var filterTableRows = function filterTableRows(leftFilter, rightFilter) {
    var data = [children.find(function (x) {
      return x.type === 'table';
    })];
    try {
      return data === null || data === void 0 ? void 0 : data.map(function (child) {
        var _child$props;
        var rows = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children;
        var filteredRows = rows.map(function (row) {
          var _row$props, _row$props2;
          var leftCell = (_row$props = row.props) === null || _row$props === void 0 ? void 0 : _row$props.children.find(function (cell) {
            return cell.key === (leftFilter === null || leftFilter === void 0 ? void 0 : leftFilter.value);
          });
          var rightCell = (_row$props2 = row.props) === null || _row$props2 === void 0 ? void 0 : _row$props2.children.find(function (cell) {
            return cell.key === (rightFilter === null || rightFilter === void 0 ? void 0 : rightFilter.value);
          });
          return _objectSpread2(_objectSpread2({}, row), {}, {
            props: _objectSpread2(_objectSpread2({}, row.props), {}, {
              children: [leftCell, rightCell].filter(Boolean)
            })
          });
        });
        return _objectSpread2(_objectSpread2({}, child), {}, {
          props: _objectSpread2(_objectSpread2({}, child.props), {}, {
            children: filteredRows
          })
        });
      });
    } catch (error) {
      console.error('Error filtering rows:', error); // eslint-disable-line no-console
      return data;
    }
  };
  useEffect(function () {
    if (!showMobileComparison || typeof window === 'undefined') {
      return;
    }
    if (leftColumnFilter && rightColumnFilter) {
      try {
        var newTableData = filterTableRows(leftColumnFilter, rightColumnFilter);
        setTableData(newTableData);
      } catch (error) {
        console.error('Error in filtering rows:', error); // eslint-disable-line no-console
        setTableData(children);
        setIsError(true);
      }
    }
  }, [leftColumnFilter, rightColumnFilter, children]); // eslint-disable-line react-hooks/exhaustive-deps

  var onLeftColumnSelect = function onLeftColumnSelect(option) {
    if (option.value === rightColumnFilter.value) {
      setLeftColumnError(true);
    } else {
      setLeftColumnError(false);
      setRightColumnError(false);
      setLeftColumnFilter(option);
    }
  };
  var onRightColumnSelect = function onRightColumnSelect(option) {
    if (option.value === leftColumnFilter.value) {
      setRightColumnError(true);
    } else {
      setRightColumnError(false);
      setLeftColumnError(false);
      setRightColumnFilter(option);
    }
  };
  return /*#__PURE__*/React__default.createElement(TableWrapper, {
    className: "leshen-table-wrapper",
    leftColumnAlignment: leftColumnAlignment
  }, showMobileComparison ? /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Dropdowns, null, /*#__PURE__*/React__default.createElement(DropdownWrapper, null, /*#__PURE__*/React__default.createElement(ErrorWrapper, {
    showError: leftColumnError
  }, "Select a new option"), /*#__PURE__*/React__default.createElement(Dropdown, {
    placeholderText: leftColumnFilter === null || leftColumnFilter === void 0 ? void 0 : leftColumnFilter.label,
    options: columnOptions,
    onChange: onLeftColumnSelect
  })), /*#__PURE__*/React__default.createElement(DropdownWrapper, null, /*#__PURE__*/React__default.createElement(ErrorWrapper, {
    showError: rightColumnError
  }, "Select a new option"), /*#__PURE__*/React__default.createElement(Dropdown, {
    placeholderText: rightColumnFilter === null || rightColumnFilter === void 0 ? void 0 : rightColumnFilter.label,
    options: columnOptions,
    onChange: onRightColumnSelect
  }))), tableData[0]) : children);
};
var Table$1 = Table;

export { Table$1 as default };
//# sourceMappingURL=index.js.map
